export type SingleStatistic = {
	upAccountId: string;
	accountId: string;
	mobilePrepaid: number;
	mobilePostpaid: number;
	internet: number;
	fix: number;
};

const model: types.models.InputModel = {
	upAccountId: 'upAccountId',
	accountId: 'accountId',
	mobilePrepaid: 'mobilePrepaid',
	mobilePostpaid: 'mobilePostpaid',
	internet: 'internet',
	fix: 'fix',
};

export default model;
